import React from 'react';
import './GroupModal.scss';
import i18next from 'i18next';
import {toast} from 'react-toastify';
import GeneralModal from '../../Modals/GeneralModal/GeneralModal';
import {NOTIFY_OPTS} from '../../constants/Notifiers';
import {Translation} from 'react-i18next';
import LabeledDropDown from '../../Custom UI/LabeledInputs/LabeledDropDown/LabeledDropDown';
import LabeledTextInput from '../../Custom UI/LabeledInputs/LabeledTextInput/LabeledTextInput';
import {languageOptions} from '../../Helpers/Helpers';

const notifyGroupUpdateError = (aError) => toast(<Translation>{ (t, { i18n }) => t('ERROR_UPDATING_GROUP', {error:aError}) }</Translation>, NOTIFY_OPTS.autoCloseThreeSeconds);
const notifyGroupUpdateSuccess = (aGroupName) => toast(<Translation>{ (t, { i18n }) => t('GROUP_UPDATED_SUCCESS', {groupName:aGroupName}) }</Translation>, NOTIFY_OPTS.autoCloseThreeSeconds);

export default class GroupModal extends React.Component {
  
  // Init
  
  constructor(props) {
    super(props);
    this.state = {
      groupName:'',
      groupLocale:'en'
    };
  }
  
  componentDidMount(){
    if(this.props.group){
      this.setState({groupName:this.props.group.name, groupLocale:this.props.group.locale});
    }
  }
  
  componentDidUpdate(prevProps, prevState, snapshot){
    if(prevProps.group !== this.props.group && this.props.group){
      this.setState({groupName:this.props.group.name, groupLocale:this.props.group.locale});
    }
  }
  
  // Methods
  
  updateGroup = () => {
    this.props.updateGroup(this.props.group.id, this.state.groupName, this.state.groupLocale).then((newResponse) => {
      let group = newResponse.data.data.updateGroup.group;
      notifyGroupUpdateSuccess(group.name);
      this.props.handleCloseModal(group);
    }, (aError) => {
      notifyGroupUpdateError(aError);
    });
  };
  
  // Render
  
  render() {
    const { groupName, groupLocale } = this.state;
    const { isOpen, handleCloseModal } = this.props;
    
    return (
      <GeneralModal title={<span>{groupName}</span>}
                    isOpen={isOpen}
                    isEditing={true}
                    showSaveButton={true}
                    showCancelButton={true}
                    handleSave={() => this.updateGroup()}
                    containsDropDown={true}
                    handleCloseModal={() => handleCloseModal(null)}>
          <LabeledTextInput className="modal-input"
                            label={<Translation>{ (t, { i18n }) => t('NAME')}</Translation>}
                            value={groupName}
                            handleSave={(aEvent) => this.setState({groupName:aEvent.target.value})}
                            placeholder={i18next.t('NAME')}
          />
          
          <LabeledDropDown className="modal-input"
                           label={<Translation>{ (t, { i18n }) => t('LOCALE')}</Translation>}
                           value={groupLocale && languageOptions.filter(function(option){
                             return option.value === groupLocale;
                           })}
                           options={languageOptions}
                           handleSave={(aOption) => {this.setState({groupLocale:aOption.value})}}
          />
      
      </GeneralModal>
    )
  }
}
